import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateApi } from "../../../../api/api";
import { SplitReservationPayloadType } from "../../schema/SplitReservationSchema";
import { toast } from "sonner";
import { extractErrorMessage } from "../../../../shared/utils/serverValidation";

const API_VERSION = "v4";

const useSplitReservation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: SplitReservationPayloadType) => {
            const response = await privateApi.post(`/${API_VERSION}/booking/split-reservation`, payload);
            return response.data;
        },
        onSuccess: async () => {
            // Invalidate calendar data
            await queryClient.invalidateQueries({ queryKey: ['bookings'] });
            toast.success("Reservation split successfully");
        },
        onError: (error: any) => {
            toast.error(extractErrorMessage(error, "Failed to split reservation"));
        }
    });
};

export default useSplitReservation;
